import React, { useState } from "react";
import { useSelector } from "react-redux";
import { LanguageLoader } from "../../assets/languages";
import Modal from "./Modal";
import { GetModuleListAPI } from "../../services";
import Accordion from "./Accordion";

const FAQ = () =>
{
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const [category, SetCategory] = useState('');
	const [subCategories, SetSubCategory] = useState([]);
	const [articles, SetArticles] = useState([]);
	const [loading, SetLoading] = useState(true);
	const [articleLoading, SetArticleLoading] = useState(true);
	
	const GetData = async (id='') =>
	{
		SetLoading(true);
		if(id.length)
		{
			SetArticleLoading(true);
		}
		SetSubCategory([]);
		SetArticles([]);
		SetCategory('');
		try {
			let queryString = '`knowledge_base_categories`.`visible_in_portal_and_ticket`="1" AND '; /* Condition for display knowledgeBase */
			queryString += id.length ? '`knowledge_base_categories`.`parent_category_id`="'+id+'"' : '`knowledge_base_categories`.`parent_category_id` IS NULL OR `knowledge_base_categories`.`parent_category_id`=""';
			const data = {
				selected_fields: ['id', 'name'],
				query : queryString,
			};
			GetModuleListAPI('Knowledge_Base_Categories', data).then(APIResponse => 
			{
				SetCategory(id);
				SetSubCategory(APIResponse || []);
				SetLoading(false);
				const data = {
					selected_fields: ['id', 'name', 'description'],
					query : '`knowledge_base`.`visible_in_portal_and_ticket`="1" AND `knowledge_base`.`parent_category_id`="'+id+'"',
				};
				GetModuleListAPI('Knowledge_Base', data).then((ArticleAPI) =>
				{
					SetArticles(ArticleAPI || []);
					SetArticleLoading(false);
				});
			});
		} catch (error) {}
	};

	return <Modal handler={<button type='button' className="btn btn-secondary" onClick={GetData}>{language.FAQ}</button>} title={language.FAQ}>
		{loading ? <i className="fa fa-spin fa-spinner text-primary mx-2 my-3"></i> : null}
		<div className="flex flex-wrap">
		{category.length ? <button className="btn btn-secondary" onClick={() => GetData('')}>
			<i className="fa fa-home me-2"></i>
			{language.AUTHENTICATION.RETURN}
		</button> : null}
		{subCategories.map((item, index) => {
			return <div className="w-1/2 px-2 md:w-auto md:px-0"><button className="btn w-full btn-secondary md:w-auto" key={index} onClick={() => GetData(item.id)}>{item.name}</button></div>
		})}
		</div>
		<div className="min-h-[150px] max-h-[500px] overflow-auto">
		{articleLoading ? <div className="mt-2"><i className="fa fa-spin fa-spinner text-primary mx-2 my-3"></i></div> : null}
		{articles.length ? <div className="mt-4 mx-1">
			{articles.map((item, index) => <Accordion key={index} title={item.name} content={item.description}/>)}
		</div> : null}
		</div>
	</Modal>
}

export default FAQ;